import PropTypes from 'prop-types';
import React from 'react';

import { insertNewLine, generateKey } from '@/utils';
import { TABLET_L } from '@/constants';
import {
  Section,
  Wrapper,
  Outer,
  Container,
  PanelWrapper,
  PanelImage,
  PanelTitle,
  PanelDescription,
  MarkdownStyle,
} from '@/components/Article/ImagePanelsSection.style';

// パネル数判定用 広域変数
const PANEL_LENGTH_ONE = 1;
const PANEL_LENGTH_THREE = 3;

/**
 * イメージパネル
 *   * SP 版、且つ、パネル 2 つ以上の場合は、X 軸方向にスクロールさせる。
 */
const ImagePanelsSection = ({ entryId, imagePanelsSection, screenSize }) => (
  <Section id={entryId} scrollableX={!!(screenSize < TABLET_L && imagePanelsSection.length > PANEL_LENGTH_ONE)}>
    <Wrapper scrollableX={!!(screenSize < TABLET_L && imagePanelsSection.length > PANEL_LENGTH_ONE)}>
      <Outer>
        <Container key={entryId} className={imagePanelsSection.length < PANEL_LENGTH_THREE && 'columnLessThanThree'}>
          {imagePanelsSection.map(({ title, description, image }, index) => (
            <PanelWrapper
              key={generateKey('image-panels-section', index)}
              className={imagePanelsSection.length === PANEL_LENGTH_ONE && 'columnOne'}
            >
              <PanelImage
                src={image.file.url}
                alt={image.title}
                className={imagePanelsSection.length === PANEL_LENGTH_ONE && 'columnOne'}
              />
              <PanelTitle>{title}</PanelTitle>
              <PanelDescription>
                {insertNewLine({
                  key: 'image-panel-section-more-than-three-column',
                  description,
                  component: MarkdownStyle,
                })}
              </PanelDescription>
            </PanelWrapper>
          ))}
        </Container>
      </Outer>
    </Wrapper>
  </Section>
);

ImagePanelsSection.defaultProps = {
  entryId: undefined,
  imagePanelsSection: [],
  screenSize: null,
};

ImagePanelsSection.propTypes = {
  entryId: PropTypes.string,
  imagePanelsSection: PropTypes.arrayOf(PropTypes.shape()),
  // スクリーンサイズ
  screenSize: PropTypes.number,
};
export default ImagePanelsSection;



// WEBPACK FOOTER //
// ./src/components/Article/ImagePanelsSection.js